<template>
  <div class="card1">
    <div class="card2">
      <div class="container-fluid mt-4" v-for="item in certificate" :key="item.id">
          <div class="container-fluid" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
            <center><span class="text-black display-4" style="font-family: Certificate Font;">BIRTH NOTIFICATION FORM</span></center>
            <center><span class="text-black h6">This certifies that</span></center>
            <div class="row">
              <div class="col-4">
                <img src="@/assets/images/mombaby.png" height="80"/>
              </div>
              <div class="col-4 text-center"></div>
              <div class="col-4 text-end">
                <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="80"/></span>
                <span v-else><img src="@/assets/images/logo.png" height="80"/></span>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <h4 class="text-uppercase patient">{{ item.patient.name }}</h4>
            </div>
            <hr class="hr-1 mt-n1 bg-dark">
            <center><span class="text-black h5">was born to</span></center>
            <div class="row">
              <div class="col-4 text-center">Mother: <span class="h4 text-black">{{ item.mother }}</span></div>
              <div class="col-4 text-end"></div>
              <div class="col-4 text-center">Father: <span class="h4 text-black">{{ item.father }}</span></div>
            </div>

            <div class=" mt-3 d-flex justify-content-center h5"><span>at <span class="h4 text-black">{{ userData.business }}</span>, <span class="text-black h5">{{ userData.location }}</span></span></div>
              
            <!-- <div class=" m-3 d-flex justify-content-center h5"><span>on <span class="h4 text-black">{{ item.date_of_birth }}</span>, <span>at <span class="h4 text-black">{{ item.time_of_birth }}</span></span></span></div> -->
            
            <div class=" m-3 d-flex justify-content-center h5"><span>Unit No .........................</span></div>

            <div class=" m-3 d-flex justify-content-center h5"><span>Weighing <span class="h4 text-black">{{ item.birth_weight }}</span>,</span> <span>with  <span class="h4 text-black">{{ item.score }}</span> <span>as the APGAR Score</span></span></div>
           
            <div class="row">
              <div class="col-4 text-center">on <span class="h4 text-black">{{ item.date_of_birth }}</span></div>
              <div class="col-4 text-end"></div>
              <div class="col-4 text-center">at <span class="h4 text-black">{{ item.time_of_birth}}</span></div>
            </div>
            
         <div v-show="item.maturity !== null">   <div class=" m-3 d-flex justify-content-center h5" ><span>Maturity <span class="h4 text-black">{{ item.maturity }}</span></span></div></div>


         <div  v-show="item.comment !== null">   <div class=" m-3 d-flex justify-content-center h5"><span>Comments <span class="h4 text-black">{{ item.comment }}</span></span></div> </div>
 
            <div class="text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }} | Via Afrimed Software | www.afrimed.com </p>
            </div>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      certificate:[],
    };
  },
  created() {
    this.showCertificate();
  },
  methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    async showCertificate(){
      this.id=this.$route.query.id;
      let url = `/patientbirthcertificate/${this.id}`;
      await axios.get(url).then((response) => {
        this.certificate = response.data.certificates;
        setTimeout(() => {
            window.print();
            window.onafterprint=this.$router.go(-1);
        }, 500);
      });
    },
  },
};
</script>

<style>
  .card1{
    border: 5px solid black;
    margin: 10px;
  }
  .card2{
    border: 1px solid black;
    margin: 10px;
  }
  .patient{
    color: black;
    letter-spacing: 4px;
  }
  hr.hr-1 {
  margin: 100px;
  margin-bottom: 30px;
  border-top: 2px solid black;  
}
</style>